import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { setCurrentZoneStep } from '../../../../../action/roomControlAction'
import WindowZonesStep1 from './WindowZonesStep1'
import WindowZonesStep2 from './WindowZonesStep2'
import WindowZonesStep3 from './WindowZonesStep3'

function WindowZones(props) {
  return (
    <>
      { props.currentZoneStep == 1 && <WindowZonesStep1 goNext={() => props.setCurrentZoneStep(2)} goBack={props.goBack}/>}
      { props.currentZoneStep == 2 &&<WindowZonesStep2 goNext={() => props.setCurrentZoneStep(3)} goBack={() => props.setCurrentZoneStep(1)}/>}
      { props.currentZoneStep == 3 &&<WindowZonesStep3 goBack={() => props.setCurrentZoneStep(2)} />}
    </>
  )
}

const mapStateToProps = state => {
  return {
    tintControlData: state.store.TintControlData,
    selectedWindows: state.store.selectedWindows,
    currentZoneStep: state.store.currentZoneStep
  }
}

export default connect(mapStateToProps, {setCurrentZoneStep})(WindowZones)